import { render, staticRenderFns } from "./companyBussi.vue?vue&type=template&id=0db3fa23&scoped=true&"
import script from "./companyBussi.vue?vue&type=script&lang=js&"
export * from "./companyBussi.vue?vue&type=script&lang=js&"
import style0 from "./companyBussi.vue?vue&type=style&index=0&id=0db3fa23&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3fa23",
  null
  
)

export default component.exports